/**
 * RESPONSIBILITY: the Children's page introduction band.
 */
import { Html } from '@framework/react';
import type { ChildrenIntroSection } from '@app/sections';
import { Picture } from '../commons/Picture';

export function ChildrenIntro({ c }: { c: ChildrenIntroSection }) {
  return (
    <section className="band band-tint">
      <div className="wrap split split-reverse">
        <Picture value={c.introImage} alt="" className="block-pic" />
        <div className="stack">
          {c.introEyebrow && <p className="eyebrow">{c.introEyebrow}</p>}
          {c.introHeading && <h2>{c.introHeading}</h2>}
          {c.introHtml && <Html className="md-body lede">{c.introHtml}</Html>}
        </div>
      </div>
    </section>
  );
}
